import React, { useState, useEffect } from 'react';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { TFunction } from 'i18next';
import { MensajesChatObj } from '@/objects/Chat';
import ImageRound from '../../ImageRound';
import { comprobarAvatar } from '@/util/Articulos';
import { dateToTextTForm, obtenerHoraTForm } from '@/util/MagicDate';
import { azulClaro, moradoOscuro, primary, white } from '@/constants/Colors';
import Texto from '../../Texto';
import { Card } from '@mui/material';
import { textosMini } from '@/constants/Dimens';
import DoneAllIcon from '@mui/icons-material/DoneAll';

let t = '';

let imagenMia: string = "";
let idUsuario: number;

interface Props {
  t: TFunction;
  mensaje: MensajesChatObj;
}

const RowMensaje: React.FC<Props> = ({ t, mensaje }) => {

  const [idUsuarioSet, setIdUsuario] = useState<Number>();

  const id_chat = mensaje.id_chat;
  const id_autor = mensaje.id_autor;
  let mensajeTexto = mensaje.mensaje;
  const fecha = mensaje.fecha;
  const avatar_otro = mensaje.avatar_otro;

  if (mensajeTexto.includes('{code')) {
    mensajeTexto = 'Solicitud de intercambio';
  } else if (mensajeTexto.includes('{/code')) {
    mensajeTexto = 'Trato';
  }

  useEffect(() => {
    const datosUsuario = cargarDatosUsuario();
    idUsuario = Number(datosUsuario?.id_user);
    imagenMia = String(datosUsuario?.image);
    setIdUsuario(idUsuario);
  }, []);

  const styles: { [key: string]: React.CSSProperties } = {
    contenedorImagenChat: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      margin: 5,
    },
    contenedorChatDerecha: {
      flex: 12,
      backgroundColor: primary,
      borderRadius: 12,
      margin: 5,
      padding: "20px",
      alignItems: "flex-end",
      justifyContent: "center"
    },
    contenedorChatIzquierda: {
      flex: 12,
      backgroundColor: white,
      borderRadius: 15,
      margin: 5,
      padding: "20px",
      alignItems: "flex-start",
      justifyContent: "center",
    },
    textoChat: {
      color: 'white',
      fontSize: 16,
      fontWeight: "300",
    },
    fechaChat: {
      color: 'white',
      fontSize: 10,
      fontWeight: "300",
    },
    contenedorExtraChat: {
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    filaChatDerecha: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "flex-end",
      width: "600px",
    },
    filaChatIzquierda: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "600px",
    },
  }

  if (idUsuarioSet !== null) {
    return (
      idUsuario == id_autor ? ( //Mis mensajes
        <article key={id_chat} style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: "10px" }}>
          <div style={{ ...styles.filaChatDerecha }}>
            <Card style={styles.contenedorChatDerecha}>
              <Texto color={white}>{mensajeTexto}</Texto>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <DoneAllIcon style={{ color: mensaje.leido ? azulClaro : white, width: "15px", height: "15px", marginRight: "3px" }} />
                <Texto fontSize={textosMini} color={white}>{dateToTextTForm(fecha, t) + " " + obtenerHoraTForm(fecha)}</Texto>
              </div>
            </Card>
            <div style={{ ...styles.contenedorImagenChat }}>
              <ImageRound src={comprobarAvatar(imagenMia)} title={t("contenido:user.card_user.title_user")} alt={"contenido:user.card_user.alt_user"} />
            </div>
          </div>
        </article>
      ) : ( //mensajes del otro participante
        <article key={id_chat} style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', marginBottom: "10px" }}>
          <div style={{ ...styles.filaChatIzquierda }}>
            <div style={{ ...styles.contenedorImagenChat }}>
              <ImageRound src={comprobarAvatar(String(avatar_otro))} title={t("contenido:user.card_user.title_user")} alt={"contenido:user.card_user.alt_user"} />
            </div>
            <Card style={{
              ...styles.contenedorChatIzquierda,
              ...(id_autor === -1 ? { backgroundColor: moradoOscuro } : {})
            }}>
              <Texto color={id_autor === -1 ? white : primary}>{mensajeTexto}</Texto>
              <div >
                <Texto fontSize={textosMini} color={id_autor === -1 ? white : primary}>{dateToTextTForm(fecha, t) + " " + obtenerHoraTForm(fecha)}</Texto>
              </div>
            </Card>
          </div>
        </article >
      )
    )
  } else {
    return null;
  }
};

export default RowMensaje;